module.exports = __webpack_public_path__ + "static/media/instrukcja.255f9b9a.gif";